<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @ok="save"
            @hidden="hidden"
        >

            <template #modal-title>
                Edit Image
            </template>

            <b-form-group
                label="Merlin ID"
                label-for="merlin_id"
            >
                <b-form-input :value="editable_image.merlinid" readonly />
            </b-form-group>

            <b-form-group
                label="Width"
                label-for="width"
            >
                <!-- <b-form-input v-model="editable_image.width" /> -->

                <b-form-group class="p-1 pt-3 text-center">
                    <b-form-select
                        v-model="editable_image.width"
                        :options="width_options"
                    ></b-form-select>
                </b-form-group>
            </b-form-group>

            <b-form-group
                label="Align"
                label-for="align"
            >
                <b-form-select v-model="editable_image.align">
                    <b-form-select-option value="">

                    </b-form-select-option>
                    <b-form-select-option value="left">
                        Left
                    </b-form-select-option>
                    <b-form-select-option value="right">
                        Right
                    </b-form-select-option>
                    <b-form-select-option value="behind">
                        Center Behind Text
                    </b-form-select-option>
                    <b-form-select-option value="front">
                        Center In Front of Text
                    </b-form-select-option>
                    <b-form-select-option value="topandbottom">
                        Top and Bottom
                    </b-form-select-option>
                </b-form-select>
            </b-form-group>

            <b-form-group
                label="Alt"
                label-for="alt"
            >
                <b-form-textarea v-model="editable_image.alt" rows="2" max-rows="6" />
            </b-form-group>

            <b-form-group
                label="Caption"
                label-for="caption"
            >
                <b-form-textarea v-model="editable_image.caption" rows="2" max-rows="6" />
            </b-form-group>

            <b-form-group label="Credit" label-for="credit">
                <b-form-textarea v-model="editable_image.credit" rows="2" max-rows="6" />
            </b-form-group>

            <b-form-group label="Description" label-for="description">
                <b-form-textarea v-model="editable_image.description" rows="2" max-rows="6" />
            </b-form-group>

            <div class="alert alert-primary" role="alert">
                Editing the Merlin Media Item will only effect this instance of the Media.
            </div>

            <template #modal-footer>
                <b-button variant="light" @click="cancel">
                    Cancel
                </b-button>
                <b-button variant="primary" @click="save">
                    Save Changes
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
.url,
.message {
    .copy-to-clipboard {
        visibility: hidden;
    }
    &:hover {
        .copy-to-clipboard {
            visibility: visible;
        }
    }
}
</style>

<script>
export default {
    data: () => ({
        editable_image: {},
        width_options: [ 10, 15, 20, 25, 30, 33, 40, 45, 50, 60, 66, 70, 75, 80, 90, 100 ],
    }),
    props: [
        'value',
        'view',
        'image'
    ],
    components: {

    },
    computed: {
        modal_id () {
            let modal_id = 'edit-merlin-image-modal'
            return modal_id
        }
    },
    watch: {
        value: {
            handler (value) {
                if (value == true) {
                    if (this.image) {
                        if (this.image.width) {
                            this.image.width = this.image.width.replace('%', '')
                        }

                        this.editable_image = this.image
                    }
                }
            }
        }
    },
    methods: {
        save () {
            this.$emit('save', this.editable_image.width, this.editable_image.align, this.editable_image.caption, this.editable_image.alt, this.editable_image.credit, this.editable_image.description)
        },
        cancel (event) {
            event.preventDefault()

            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')

            if (
                this.view &&
                this.view.dom
            ) {
                this.view.dom.focus()
            }
        }
    },
    mounted () {

    }
}
</script>
